import React from 'react';
import './../App.css';
import BlueTicket from '../Components/BlueTicket';
import Search from '../Components/Search';
import Article from '../Components/Article';
import Editor from '../Components/Editor';
import SideBar from '../Components/SideBar';
import methodsOneContext from '../Contexts/MethodsOne';
import GoodsContainer from '../Components/GoodsContainer'
import PartialSite1 from '../Components/PartialSite1'
import ScrollAnimation from 'react-animate-on-scroll';
import GoodBlock from './../Components/GoodBlock'; 


export default class App extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props.history.location.pathname);
  }
  
  state = {
    detailList : [],
    editId : -1
   }

   setDetailList(data){

      this.setState(prevState => {
        return {
          detailList : data,
          editId : -1
        }
      })

   }

   editDetail(id){
    this.setState(prevState => {
      return {
        editId : id
      }
    })
  }

    newEvent(){
      this.setState(prevState => {
        return { 
          detailList : [{Id:0 ,Description:'', Tag:''}],
          editId : 0
        }
      })

    console.log('رسsadadsadیدم');
    console.log(this.state);
    console.log(this.state.detailList);

   }

  render() {
    let detailList = this.state.detailList;
    let editId = this.state.editId;
    return (

      <>
                <div class="header_section">
                {/* <ScrollAnimation animateIn="fadeIn">
                    <PartialSite1 />
                </ScrollAnimation> */}
                </div>
                <div class="co-padding gray_bg">
   <div class="box container">
   <ScrollAnimation animateIn="fadeIn">
     <div class="multibox-head">
       <ul class="multibox-head__list">
         <li class="active">
           <a href="#">همکاری در پروژه های ملی </a>
         </li> 
         {/* <li class="">
           <a href="#">دوره&zwnj;های پیشنهادی</a>
         </li> */}
       </ul> 
       {/* <a href="/series" class="btn-more">مشاهده همه دوره&zwnj;ها</a> */}
     </div> 
     <div class="box_section ">

                        {/* <GoodBlock
                         title="آموزش انگولار" 
                         description= {<p class="description">آموزش انگولار دوره&zwnj;ای است که ما قصد داریم، شما را به شکل دقیق و پرجزئیات با فریمورک جاوااسکریپتی انگولار آشنا کنیم. فریمورک انگولار یکی از کامل&zwnj;ترین ف..."
                         price="۱۲۵۰۰۰ تومان"
                         imageAddress= {require('./../img/node.png')}/>            */}
                         <GoodBlock
                         title="نظارت اعتباری" 
                         description= {<p class="description">وظیفه اصلی این پروژه در بانک آینده ثبت اطلاعات وام گیرنده گان حقیقی و حقوقی و ارائه اطلاعات نموداری و تحلیلی به بخش ریسک بانک با بهره گیری از اطلاعات دریافتی از شرکت خدمات می باشد.در این پروژه از تکنولوژیهای مربوط به دیتا ماینینگ  بهره گرفته شده است تا به وسیله آن نمودارها و طلاعات آماری از دیتای نرم افزار استخراج شود. پروژه تکمیلی ذینفعان واحدبرای یافتن مشتریان ذینفع که توسط آن ارتباطات بین وام گیرنده گان بر اساس الگریتمهایی که بانک مرکزی معرفی کرده مشخص میشود . این پروژه مکمل پروژه نظارت اعتباری می باشد و اطلاعات خود را در قالب نمودار به بخش ریسک بانک ارائه می دهد.</p>}
                        //  price="۱۲۵۰۰۰ تومان"
                         imageAddress= {require('./../img/AyandeBank.jpg')}/>  
                                                  <GoodBlock
                         title="پزشک خانواده" 
                         description= {<p class="description">پزشکی خانواده نوعی از طبابت است که در آن پزشکان خانواده به صورت مستقیم با خانواده‌ها در تماس هستند. این پزشکان مراقبت‌های اولیه را بر عهده دارند.این پروژه ملی در وزارت بهداشت کلید خورده واطلاعات بیماران و مراجعه کننده گان به درمانگاهها و بیمارستانها در وزارت بهداشت نگهداری میشود و توسط این نرم افزار همه مراحل کاریه پزشک خانواده مدیریت و اجرا میشود.این نرم افزار کاربران مختلفی چون پزشگان، پرستاران، بیماران، کارمندان بیمارستانها و ... را پشتیبانی میکند و نمودارهای تحلیلی به وازارت بهداشت ارائه می نماید.</p>}
                        //  price="۱۲۵۰۰۰ تومان"
                         imageAddress= {require('./../img/PezashkeKhanevade4.png')}/>  
      
                                                  <GoodBlock
                         title="سیستم جامع دریایی" 
                         description= {<p class="description">پروژه ملی سیستم جامع دریایی، بعنوان منحصر به فردترین سیستم جامع دریایی در سطح خاورمیانه، بر اساس تلفیق دو ویژگی حاکمیتی امور دریایی و نیازهای عملیاتی  امور دریایی در بنادر کشور مدل سازی شده است، و مجموعه ای از دوازده زیر سیستم است که تمامی عملیات و امور اجرایی را در حوزه امور دریایی در بنادر و سازمان مرکزی پوشش می دهد. این سامانه برای اولین بار در کشور با بهره گیری از طراحی سیستم‌های فرآیند محور و معماری سرویس گرا طراحی شده است و دارای ابعاد و دستاوردهای متعددی در سطوح مختلف می­باشد.</p>}
                        //  price="۱۲۵۰۰۰ تومان"
                         imageAddress= {require('./../img/SazmanBanader5.png')}/>  
                                                                           <GoodBlock
                         title="صندوق و سبد و بک آفیس" 
                         description= {<p class="description">به طور خلاصه کار صندوق ها این است که مبالغ کوچک را جمع آوری می کنند و این سرمایه جمع شده را به صورت تخصصی در حوزه های مختلف تحت نظارت سازمان بورس و اوراق بهادار سرمایه گذاری می کنند. هر سودی که از بابت این فعالیت حاصل شد به نسبت سهم هر سرمایه گذار تقسیم می شود. مدیر صندوق هم بابت فعالیت حرفه ای کارمزد دریافت می کند.مدیریت این فعالیت های تجاری توسط نرم افزار صندوق انجام میشود.
                         نرم افزار بک آفیس نیز توسط کارگزاریها برای انجام امور بورسی استفاده می شود.
                         </p>}
                        //  price="۱۲۵۰۰۰ تومان"
                         imageAddress= {require('./../img/TadbirPardaz4.png')}/>  
                     

               

      </div>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn">
     <div class="multibox-head">
       <ul class="multibox-head__list">
         <li class="active">
           <a href="#">پروژه های دیگر</a>
         </li> 
         {/* <li class="">
           <a href="#">دوره&zwnj;های پیشنهادی</a>
         </li> */}
       </ul> 
       {/* <a href="/series" class="btn-more">مشاهده همه دوره&zwnj;ها</a> */}
     </div> 
     <div class="box_section ">

                          <GoodBlock
                         title="فروشگاه آجیل و خشکبار" 
                         description= {<p class="description">یک فروشگاه اینترنتی و  مکانی مناسب برای خرید محصولات خشکبار باغی می باشد که در آن می توان ویترینی بزرگ از محصولات خشکبار فراهم کرد که همیشه در دسترس باشد و مشتریان در حالی که می توانند تصاویر و خصوصیات کامل محصول مورد نظر خود را سر فرصت و با خاطری آسوده مشاهده کنند ، بتوانند محصولات مورد تایید خود را در منزل یا محل کار به راحتی خریداری نمایند.</p>}
                        //  price="۱۲۵۰۰۰ تومان"
                         imageAddress= {require('./../img/AjilKade6.png')}/> 
                                                                                  <GoodBlock
                         title="سیستم جامع حقوقی" 
                         description= {<p class="description">این سامانه به شما امکان ایجاد پرونده های الکترونیکی دعاوی و املاک، بایگانی الکترونیکی اسناد و مدارک، دسترسی به گزارشات لحظه ای و آمار الکترونیکی، تولید خودکار اوراق قضایی و در نهایت مطالعه الکترونیکی پرونده ها را خواهد داد. این سامانه به عنوان ابزاری قدرتمند، اسناد و مدارک حقوقی در سازمان را مدیریت نموده و پس از ذخیره سازی الکترونیکی و تحلیل داده های اسناد، مدیران و کارشناسان حقوقی را در امر برنامه ریزی، انتخاب و اجرای فرآیند مناسب یاری می رساند.</p>}
                        //  price="۱۲۵۰۰۰ تومان"
                         imageAddress= {require('./../img/Bamdad4.png')}/> 
                                                   <GoodBlock
                         title="پروژه های دیگر" 
                         description= {
                           <>
                             <p class="description">
                               پروژه سندرومیک
                             </p>
                             <p class="description">
                               پروژه استعلام پیمانکاران
                             </p>
                             <p class="description">
                               پروژه نرم افزار پزشکی سینا
                             </p>
                             <p class="description">
                               و...
                             </p>
                           </>
                         }
                        //  price="۱۲۵۰۰۰ تومان"
                         imageAddress= {require('./../img/project-based-programming.svg.svg')}/>                          

      </div>
      </ScrollAnimation>
    </div>
  </div>

      </>
    )
  }
}


